import React, { Component } from "react";
import parser from "xml2js";
import axios from "axios";

import "./App.css";
import Header from "./components/Header";
import TopInfo from "./components/TopInfo";
import Documents from "./components/Documents";
import Anuncios from "./components/Anuncios";
import Footer from "./components/Footer";

export class App extends Component {
  state = {
    geral: [],
    docentes: [],
    alunos: [],
  };

  componentDidMount() {
    axios
      .get(
        "https://webdocs.ipb.pt/portal/entity.xml?entityId=8408&start=8408&localeId=1"
      )
      .then((res) => {
        parser.parseString(res.data, (err, result) => {
          if (err) {
            console.log(err);
            return;
          }
          result.entity.docs.map((doc) => {
            this.setState({ geral: doc.doc });
            return true;
          });
        });
      });

    axios
      .get(
        "https://webdocs.ipb.pt/portal/entity.xml?entityId=8389&start=8389&localeId=1"
      )
      .then((res) => {
        parser.parseString(res.data, (err, result) => {
          if (err) {
            console.log(err);
            return;
          }
          result.entity.docs.map((doc) => {
            this.setState({ docentes: doc.doc });
            return true;
          });
        });
      });

    axios
      .get(
        "https://webdocs.ipb.pt/portal/entity.xml?entityId=8390&start=8390&localeId=1"
      )
      .then((res) => {
        parser.parseString(res.data, (err, result) => {
          if (err) {
            console.log(err);
            return;
          }
          result.entity.docs.map((doc) => {
            this.setState({ alunos: doc.doc });
            return true;
          });
        });
      });
  }

  render() {
    return (
      <div className="App">
        <Header />
        <TopInfo />
        <Documents links={this.state} />
        <Anuncios />
        <Footer />
      </div>
    );
  }
}

export default App;
